import ListingCard from './ListingCard.jsx'
import { alertLabel, noteFor } from '../util.js'

/**
 * Bikes that pushed a notification and have not been looked at since.
 *
 * Pinned above everything in both views. Without it, tapping a push opens the
 * full list with no indication of which bike caused it — which is the state
 * this replaces.
 *
 * Renders nothing when empty rather than an empty section: a permanent "New
 * activity 0" header trains the eye to ignore the one place that must never be
 * ignored.
 */
export default function Inbox({ listings, notes, onOpen, onStatus, onMarkAll }) {
  if (!listings.length) return null

  return (
    <section className="inbox">
      <div className="section-head static">
        <h2>New activity <span className="count">{listings.length}</span></h2>
        <button className="link-btn" onClick={() => onMarkAll?.(listings.map((l) => l.id))}>
          Mark all reviewed
        </button>
      </div>

      <div className="grid">
        {listings.map((l) => (
          <div key={l.id} className="inbox-item">
            <p className="why">{alertLabel(l)}</p>
            <ListingCard
              listing={l}
              note={noteFor(notes, l.id)}
              onOpen={onOpen}
              onStatus={onStatus}
            />
          </div>
        ))}
      </div>
    </section>
  )
}
